import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useQuery, useMutation } from '@apollo/client'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import pdfIcon from '../../../../Assets/icons/pdf.svg'
import moment from 'moment'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import GlobeIcon from '../../../../Assets/icons/Icon awesome-globe-africa.svg'
import IncognitoIcon from '../../../../Assets/icons/incognito.svg'
import MigrantsInternalNotesMenuMessageContent from './MigrantsInternalNotesMenuMessageContent'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'
import { CREATE_MIGRANTS_INTERNAL_NOTE, GET_MIGRANTS_INTERNAL_NOTES } from '../../../../graphql/Catalog/Migrants/migrantsInternalNotes'

const MigrantsInternalNotes = ({
  category_note = 'reports',
  category_notes_status = 'status',
  document_id,
  jurisdiction_id,
  flagSwitchInternalMode = true,
  OnlyInternalMessages = false,
  refetchNotes = false,
  user,
}) => {
  const { showLoading, hideLoading } = useLoading()

  //--------- Hooks to save data ------------
  const [values, setValues] = useState({
    text: '',
    document: '',
    internal: false,
  })
  const [messages, setMessages] = useState(null)
  const [previewFile, setPreviewFile] = useState(null)
  const [loadingUpload, setLoadingUpload] = useState(false)
  const { text, document } = values
  const refResetDocument = useRef()
  const boxScroll = useRef()

  //---------- Queries and Mutations ---------
  const [createNote] = useMutation(CREATE_MIGRANTS_INTERNAL_NOTE, {
    refetchQueries: [
      {
        query: GET_MIGRANTS_INTERNAL_NOTES,
        variables: {
          document_id,
        },
        fetchPolicy: 'no-cache',
      },
    ],
  })
  const { data, loading, error, refetch } = useQuery(GET_MIGRANTS_INTERNAL_NOTES, {
    variables: {
      document_id,
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (refetchNotes) {
        const refetchData = async () => {
          await refetch()
        }

        refetchData()
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [refetchNotes])

  //---------- UseEffects ----------
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      //PINTAR DATOS EN INTERNAL
      let list = []
      let internal = false
      data?.getMigrantsInternalNotes?.map((item) => {
        // if (
        //   (item.internal && user?.jurisdiction_id !== jurisdiction_id) ||
        //   !item.internal
        // ) {
        if (
          category_notes_status !== item?.category_note &&
          user?.idUser == item?.JobPositionOfUser?.id
        )
          internal = item?.internal

        list.push({
          id: item?.id ? item.id : '',
          status: item?.InternalNotesToStatus?.name
            ? item.InternalNotesToStatus.name
            : '',
          status_data: item?.InternalNotesToStatus,
          user_id: item?.MigrantsInternalNotesToUser?.id
            ? item.MigrantsInternalNotesToUser.id
            : '',
          user: item?.MigrantsInternalNotesToUser?.name
            ? item.MigrantsInternalNotesToUser.name
            : '',
          charge:
            item?.MigrantsInternalNotesToUser?.type_user == 'app'
              ? 'Ciudadano'
              : item?.MigrantsInternalNotesToUser?.JobPositionOfUser?.name
              ? item.MigrantsInternalNotesToUser.JobPositionOfUser.name
              : '',
          text: item?.text ? item.text : '',
          file: item?.fileInternal?.url ? item.fileInternal.url : '',
          type: item?.type ? item.type : '',
          date: item?.createdAt
            ? moment().format('DD-MM-YYYY') ==
              moment(item.createdAt).format('DD-MM-YYYY')
              ? moment(item.createdAt).format('hh:mm a')
              : moment(item.createdAt).format('DD/MM/YY hh:mm a')
            : '',
          internal: item?.internal ? item.internal : false,
          category_note: item?.category_note,
          isStatus: category_notes_status == item.category_note,
          date_status: moment(item?.createdAt).format(
            'dddd D [de] MMMM [de] YYYY hh:mm a'
          ),
        })
        return true
        // }
      })
      if (list.length > 0)
        setValues({
          ...values,
          internal,
        })

      setMessages(list)

      if (OnlyInternalMessages) {
        setValues({
          ...values,
          internal: true,
        })
      }
    }
  }, [data, loading, error])

  const handleChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
    })
  }

  const sendInternalNotes = async () => {
    //Validate inputs data
    if (text.trim() === '' && !document) {
      setValues({
        ...values,
        text: '',
      })
      return toastSweetAlert({
        mode: 'error',
        message: 'No se puede enviar un mensaje vacío',
      })
    }

    if (!text && !document)
      return toastSweetAlert({
        mode: 'error',
        message: 'Debe escribir o subir un documento',
      })

    setLoadingUpload(true)
    showLoading()

    let type = null

    if (document) {
      type = document.type.split('/')
      if (
        type[1] !== 'pdf' &&
        type[0] !== 'image' &&
        type[1] !== 'jpg' &&
        type[1] !== 'png' &&
        type[1] !== 'jpeg'
      ) {
        setLoadingUpload(false)
        hideLoading()

        return toastSweetAlert({
          mode: 'error',
          message: 'Archivo incompatible',
        })
      }
      if (document.size > 5242880) {
        setLoadingUpload(false)
        hideLoading()
        return toastSweetAlert({
          mode: 'error',
          message: 'Archivo es demasiado pesado',
        })
      }
    }
    //Insert data
    try {
      const isProceess = category_note === 'process'

      await createNote({
        variables: {
          inputMigrantInternalNote: {
            user_id: user?.idUser,
            document_id: document_id,
            text: text === '' ? null : text,
            file: document === '' ? null : document,
            type: document ? type[1] : null,
            internal: isProceess ? true : values.internal,
          },
        },
      })
      //If the Insert was a successfull
      setValues({
        text: '',
        document: '',
        internal: values.internal,
      })
      await refetch()
      setLoadingUpload(false)
      hideLoading()
      refResetDocument.current.value = ''
      return
    } catch (e) {
      console.log(e)
      setLoadingUpload(false)
      return toastSweetAlert({
        mode: 'error',
        message: error?.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleSetUpload = (e) => {
    setValues({ ...values, document: e.target.files[0] })
    putPreview(e)
  }

  const putPreview = (e) => {
    var fileToLoad = e.target.files[0]
    var fileReader = new FileReader()
    var base64File
    fileReader.onload = function (event) {
      base64File = event.target.result
      setPreviewFile(base64File)
    }

    fileReader.readAsDataURL(fileToLoad)
  }

  /* set Scroll to bottom position */
  useEffect(() => {
    if (boxScroll) {
      const element = boxScroll.current
      element.scrollTop = element.scrollHeight
    }
  }, [boxScroll, data, loading, error])

  const handleDeleteDoc = () => {
    return (
      setValues(...values, { text: '', document: '' }),
      setPreviewFile(null),
      (refResetDocument.current.value = '')
    )
    // document.getElementById('internalNotesDocument').value = ''
    // document.getElementById('').value = ''
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      window.document.getElementById('uploadMessage').click()
    }
  }

  return (
    <div className="row internal-notes">
      <div className="col-12">
        <div className="card">
          <div className="card-header py-1">
            <h3 className="card-title pl-3 mt-0">Notas internas</h3>
          </div>
          <div
            className={`card-body internalNotes-body ${
              loadingUpload ? 'processing-file' : ''
            }`}
          >
            {/* Show history */}
            <div ref={boxScroll} className="boxHistory">
              {messages?.length > 0 ? (
                <div className="body">
                  {messages.map((item, index) => (
                    <React.Fragment key={index}>
                      {(item.isStatus ||
                        (!item.isStatus && !values.internal) ||
                        (!item.isStatus &&
                          values.internal &&
                          item.internal)) && (
                        <div
                          className={`${item.isStatus && 'status-box'} ${
                            item?.internal && 'internal-box'
                          } msg ${
                            item?.user_id === user?.idUser &&
                            !item.isStatus &&
                            'my-msg'
                          }`}
                        >
                          <div className="mt-4 msg-header">
                            {!item.isStatus && (
                              <span className="title-details">
                                {item.user}{' '}
                                {item?.charge && `(${item?.charge})`}
                                &nbsp;&nbsp;
                              </span>
                            )}
                            {item.text === '' && item.file && (
                              <>
                                <i className="fas fa-file"></i>
                                {item?.internal ? (
                                  <i className="fas fa-lock ml-1"></i>
                                ) : (
                                  <i className="fas fa-globe ml-1"></i>
                                )}
                              </>
                            )}
                            {item.text && !item.isStatus && (
                              <>
                                {item?.internal ? (
                                  <img src={IncognitoIcon} alt="incognito" />
                                ) : (
                                  <img src={GlobeIcon} alt="globe" />
                                )}
                              </>
                            )}

                            {item.isStatus && item?.status_data && (
                              <div className={`${'status-date'}`}>
                                {item.date_status}
                              </div>
                            )}
                          </div>

                          {!item.isStatus && (
                            <div className="msg-content-header">
                              <MigrantsInternalNotesMenuMessageContent
                                messageId={item?.id}
                                messageType={item?.isStatus}
                                messageContent={item}
                                refetchMessages={refetch}
                              />
                            </div>
                          )}

                          <div className={`${!item.isStatus && 'msg-content'}`}>
                            {(item.text || item.isStatus) && (
                              <>
                                <span
                                  className={`${
                                    item.isStatus
                                      ? 'content-details-status'
                                      : 'content-details'
                                  }`}
                                >
                                  {item.isStatus && item?.status_data ? (
                                    <>
                                      <div className="divider">
                                        El estado cambio a
                                      </div>
                                    </>
                                  ) : item.text && item.text.length > 300 ? (
                                    <LongText text={item.text} />
                                  ) : (
                                    <span>{item.text}</span>
                                  )}
                                </span>
                              </>
                            )}
                            {item.isStatus && item?.status_data && (
                              <div className="progress-bar-status-box">
                                <ProgressBarStatusReport
                                  statusReport={item?.status_data}
                                />
                              </div>
                            )}
                            {item.isStatus ? (
                              <>
                                <span className="status-details">
                                  {item.status_id}
                                </span>
                              </>
                            ) : (
                              <>
                                <br />
                                {item.type && item.type === 'image' && (
                                  <a
                                    href={item.file}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Ver imágen completa"
                                  >
                                    <img
                                      className="img-internal-notes hover-overlay"
                                      src={item.file}
                                      alt="Internal Notes images"
                                    />
                                  </a>
                                )}
                                {item.type && item.type === 'pdf' && (
                                  <div className="files">
                                    <a
                                      className="documentLink"
                                      href={item.file}
                                      target="_blank"
                                      rel="noreferrer"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Descargar documento"
                                    >
                                      Documento PDF &nbsp;
                                      <i className="fas fa-file"></i>
                                    </a>
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          {!item.isStatus && (
                            <div className="date mr-2">{item.date}</div>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              ) : (
                <div>
                  <div className="text-center">
                    <label>Sin historial</label>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="card-footer">
            {/* Inputs */}
            <div className="boxInput">
              <label htmlFor="internalNotesDocument" id="labelDocument">
                <i class="fas fa-plus" />
              </label>
              <input
                type="text"
                placeholder="Escribe un mensaje"
                id="internalNotesText"
                name="text"
                value={values.text}
                onChange={handleChange}
                autoComplete="off"
                onKeyDown={onKeyDown}
              />
              <input
                type="file"
                id="internalNotesDocument"
                name="document"
                onChange={(e) => handleSetUpload(e)}
                ref={refResetDocument}
                accept=".jpg, .jpeg, .png, .pdf"
              />
              <button
                id="uploadMessage"
                onClick={sendInternalNotes}
                disabled={loadingUpload}
              >
                <i className="fas fa-paper-plane"></i>
              </button>
            </div>
            {values.document && (
              <div className="preview-docs">
                {/* <span
                  style={{
                    cursor: 'pointer',
                  }}
                  className="icon-delete-document"
                  onClick={handleDeleteDoc}
                >
                  <i class="fas fa-trash"></i>
                </span> */}
                {values.document.type.includes('image') ? (
                  <img
                    src={previewFile}
                    style={{ width: '50px' }}
                    alt="previewUploadImg"
                  />
                ) : (
                  <img
                    src={pdfIcon}
                    style={{ width: '50px' }}
                    alt="previewUploadDoc"
                  />
                )}
                <label>{values.document.name}</label>
              </div>
            )}
            {flagSwitchInternalMode && (
              <div className="global-switch">
                <label className="label-description">Modo Interno</label>
                <label class="switch">
                  <input
                    checked={values?.internal}
                    type="checkbox"
                    onChange={(e) =>
                      setValues({ ...values, internal: e.target.checked })
                    }
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const LongText = ({ text = 'LongText', maxLength = 300 }) => {
  const [showMore, setShowMore] = useState(false)

  if (text.length <= maxLength) {
    return <span>{text}</span>
  }
  if (showMore) {
    return (
      <span>
        {text} &nbsp;
        <span
          className="show-more"
          onClick={() => {
            setShowMore(false)
          }}
        >
          Ver menos
        </span>
      </span>
    )
  }

  if (text.length > maxLength) {
    return (
      <span>
        {text.substring(0, maxLength)}...&nbsp;
        <span
          className="show-more"
          onClick={() => {
            setShowMore(true)
          }}
        >
          Ver más
        </span>
      </span>
    )
  }
}

MigrantsInternalNotes.propTypes = {
  category_note: PropTypes.oneOf(['reports', 'water_truck_request']).isRequired,
  document_id: PropTypes.string.isRequired,
  jurisdiction_id: PropTypes.string.isRequired,
  flagSwitchInternalMode: PropTypes.bool,
}

export default MigrantsInternalNotes
